<template>
  <div id="app">
    <keep-alive include="test">
      <router-view></router-view>
    </keep-alive>
    <vue-debug v-if="$route.query.debug" />
  </div>
</template>

<script>
import VueDebug from "@luzhongk/vue-debug";

export default {
  components: {
    VueDebug
  },
  name: "App",
  created() {
    this.setPageSize();
    window.addEventListener("orientationchange", this.listen);
  },
  beforeDestroy() {
    window.removeEventListener("orientationchange", this.listen);
  },
  methods: {
    setPageSize() {
      this.$store.dispatch("setSpaceSize");
    },
    listen() {
      setTimeout(() => {
        this.setPageSize();
      }, 100);
    }
  }
};
</script>

<style>
#__vconsole .vc-switch {
  bottom: 200px !important;
}
</style>
